import { AllMyCruisesProps } from '@msc-b2c/interfaces/types';
import ItineraryCard from '../../../itinerarycard/ItineraryCard';
import styles from './allmycruises.module.scss';
import { AllBooking, ErrorObject, TokenUpgradeResponse } from '@msc-b2c/interfaces/interfaces';
import { useNavigate } from 'react-router-dom';
import {
  clearCart,
  createNewSession,
  getActiveSession,
  openLoader,
  resetMyCruiseData,
  TokenUpgrade,
  setActiveCruiseId,
  setActiveBookingNumber,
  closeLoader,
  setErrorManagerCode,
} from '@msc-b2c/shared-utils';
import { getItineraryNameByCanvas } from '../../../utils/myAreaUtils';
import { useDispatch } from 'react-redux';
import { ErrorManagerCodeEnum } from '@msc-b2c/interfaces/enums';

const AllMyCruises = ({
  youSetSailLabel,
  youSetSailDaysLabel,
  statusLabel,
  bookedLabel,
  bookingNumberLabel,
  itineraryButtonLabel,
  itineraryButtonLink,
  viewBookingDetailsLabel,
  bookingTitleLabel,
  bookingSubtitleLabel,
  dateRangeFormatSameMonthSameYear,
  dateRangeFormatDifferentMonthSameYear,
  dateRangeFormatDifferentYear,
  onewayLabel,
  onewayDescription,
  roundtripLabel,
  roundtripDescription,
  visitingLabel,
  visitingDescriptionSeparator,
  dayFieldLabel,
  nightFieldLabel,
  cruises,
}: AllMyCruisesProps) => {
  const props = {
    youSetSailLabel,
    youSetSailDaysLabel,
    statusLabel,
    bookedLabel,
    bookingNumberLabel,
    itineraryButtonLabel,
    itineraryButtonLink,
    viewBookingDetailsLabel,
    bookingTitleLabel,
    bookingSubtitleLabel,
    dateRangeFormatSameMonthSameYear,
    dateRangeFormatDifferentMonthSameYear,
    dateRangeFormatDifferentYear,
    onewayLabel,
    onewayDescription,
    roundtripLabel,
    roundtripDescription,
    visitingLabel,
    visitingDescriptionSeparator,
    dayFieldLabel,
    nightFieldLabel,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Sort cruises by earliest departure date
  const sortedCruises = [...(cruises ?? [])].sort(
    (a, b) =>
      new Date(a.itinerary.departureDate).getTime() - new Date(b.itinerary.departureDate).getTime()
  );

  const allMyCruisesHandleClick = (bookingData: AllBooking) => {
    openLoader('.loader');
    // Call the API INT-113 (for getting the token for specific booking number)
    const loginUpgrade = new TokenUpgrade(
      false,
      false,
      {
        bookingNumber: bookingData.number,
      },
      ''
    );

    loginUpgrade
      .sendData()
      .then((res: TokenUpgradeResponse) => {
        const { email } = getActiveSession();
        createNewSession(
          res.token,
          res.loginMode,
          'mymsc',
          email,
          res.name,
          res.surname,
          res.bookingNumber,
          bookingData.cruiseId,
          res.crmasisId,
          res.goldenId,
          res.passengerId
        );

        const bookingNumber = res.bookingNumber ?? bookingData.number ?? '';
        dispatch(resetMyCruiseData());
        dispatch(setActiveBookingNumber(bookingNumber));
        dispatch(setActiveCruiseId(bookingData.cruiseId ?? null));
        dispatch(clearCart());
        //TODO remove hard coded route
        navigate(`/overview${window.location.href.includes('.html') ? '.html' : ''}`);
      })
      .catch((error: ErrorObject) => {
        closeLoader('.loader');
        if (error.code === 403 && error.issue_code === ErrorManagerCodeEnum.ACCESS_DENIED) {
          dispatch(setErrorManagerCode(ErrorManagerCodeEnum.LOGIN_ACCESS_DENIED));
        } else {
          dispatch(
            setErrorManagerCode(error.issue_code || ErrorManagerCodeEnum.GENERIC_LOGIN_ERROR)
          );
        }
      });
  };

  return (
    sortedCruises.length > 0 && (
      <div className={styles.allmycruises}>
        {sortedCruises.map((cruise, index) => (
          <ItineraryCard
            key={`${index}-${cruise.cruiseId}`} // Using itinCode or index for key
            itineraryLabels={props}
            canvasItineraryName={getItineraryNameByCanvas(cruise?.bookingData?.region ?? '')}
            bookingData={cruise.bookingData}
            itineraryData={cruise.itinerary}
            shipData={cruise.shipData}
            isAllMyCruises={true}
            imageData={cruise.imageData}
            allMyCruisesHandleClick={() => allMyCruisesHandleClick(cruise.bookingData)}
          />
        ))}
      </div>
    )
  );
};

export default AllMyCruises;
